import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchCFDHistory = async (
  authToken: string
): Promise<string[] | null> => {
  try {
    const { response, data } = await fetchFfdJson<{ body: string[]; text?: string }>(
      "/cfd/history",
      authToken
    );
    if (response.ok) {
      return data.body ?? [];
    } else {
      if (data.text) alert(data.text);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return null;
  }
};
